import * as _ from 'underscore'

import { Enums } from '../common/enums'

import { CommonHelper } from '../../helpers/common-helper'
import { Dictionary, KeyValuePair } from '../../helpers/dictionary'
import { ReferenceTypeComponent } from '../../helpers/reference-type-component'

import { Utils } from '../../models/util/utils'

import { OpDataFormatGroupDetails } from '../../models/core/op-data-format-group-details'
import { OpDistributor } from '../../models/core/op-distributor'
import { OpFile } from '../../models/core/op-file'
import { OpImportPlugin } from '../../models/util/op-import-plugin'
import { OpIssueStatusFlow } from '../../models/custom/op-issue-status-flow'
import { OpOperator } from '../../models/core/op-operator'
import { OpTaskStatusFlow } from '../../models/custom/op-task-status-flow'
import { OpView } from '../../models/core/op-view'
import { OpExportPlugin } from '../util/op-export-plugin';
import { OpPackageStatusFlow } from './op-package-status-flow';

export class OpOperatorSettings {

    // Properties

    private settings: Dictionary<any>

    // Properties end

    // Navigation Properties
    // Navigation Properties End

    // Custom Properties
    // Custom Properties End

    constructor(init: KeyValuePair<any>[] = null) {
        this.settings = new Dictionary<any>(init)
    }

    public getSettingsTypes(): Enums.SimaxOperatorSetting[] {
        if (!this.settings)
            return []
        return this.settings.keys().map(k => { return <Enums.SimaxOperatorSetting>parseInt(k.toString()) })
    }

    public containsSetting(setting: Enums.SimaxOperatorSetting): boolean {
        return this.settings && this.settings.containsKey(setting)
    }

    public setSetting(settingKey: Enums.SimaxOperatorSetting, setting: any): void {
        if (setting) {
            switch (settingKey) {
                case Enums.SimaxOperatorSetting.ActiveViews:
                    var activeViews: any[] = <any[]>setting
                    if (activeViews && activeViews.length > 0)
                        setting = activeViews.map(v => {
                            return ReferenceTypeComponent.createReferenceObject(Enums.ReferenceType.IdView, v)
                        })

                    break

                case Enums.SimaxOperatorSetting.AllowedDistributors:
                    var allowedDistributors: any[] = <any[]>setting
                    if (allowedDistributors && allowedDistributors.length > 0)
                        setting = allowedDistributors.map(v => {
                            return ReferenceTypeComponent.createReferenceObject(Enums.ReferenceType.IdDistributor, v)
                        })

                    break

                case Enums.SimaxOperatorSetting.DataTypeFormatGroup:
                    var dataTypeFormatGroup: any[] = <any[]>setting
                    if (dataTypeFormatGroup && dataTypeFormatGroup.length > 0)
                        setting = dataTypeFormatGroup.map(v => {
                            return ReferenceTypeComponent.createReferenceObject(Enums.ReferenceType.IdDataFormatGroupDetails, v)
                        })

                    break

                case Enums.SimaxOperatorSetting.ExportPlugin:
                    if (_.isArray(setting)) {
                        setting = setting.map((pluginObj: any) => new OpExportPlugin(pluginObj))
                    }

                    break

                case Enums.SimaxOperatorSetting.ImportPlugin:
                    var plugins: any[] = <any[]>setting
                    if (plugins && plugins.length > 0) {
                        setting = plugins.map(p => {
                            return new OpImportPlugin(p)
                        })
                    }

                    break

                case Enums.SimaxOperatorSetting.IssueStatusFlow:
                    if (_.isArray(setting)) {
                        setting = setting.map((issueStatusFlowObj: any) => {
                            return new OpIssueStatusFlow(issueStatusFlowObj)
                        })
                    }

                    break

                case Enums.SimaxOperatorSetting.LoggedOperator:
                    if (setting) {
                        setting = ReferenceTypeComponent.createReferenceObject(Enums.ReferenceType.IdOperator, setting)
                    }

                    break

                case Enums.SimaxOperatorSetting.Logo:
                    if (setting) {
                        var logo: OpFile = <OpFile><any>ReferenceTypeComponent.createReferenceObject(Enums.ReferenceType.IdFile, setting)

                        if (logo.fileBytes && logo.fileBytes.length > 0 && !Utils.isString(logo.fileBytes)) {
                            logo.fileBytes = CommonHelper.bin2String(<number[]>logo.fileBytes)
                        }
                        setting = logo
                    }

                    break

                case Enums.SimaxOperatorSetting.Layout:
                    var files: any[] = <any[]>setting
                    if (files && files.length > 0) {
                        if (!files.every(f => OpFile.isType(f))) {
                            setting = files.map(f => {
                                return ReferenceTypeComponent.createReferenceObject(Enums.ReferenceType.IdFile, f)
                            })
                        }
                    }

                    break

                case Enums.SimaxOperatorSetting.TaskStatusFlow:
                    if (_.isArray(setting)) {
                        setting = setting.map((taskStatusFlowObj: any) => {
                            return new OpTaskStatusFlow(taskStatusFlowObj)
                        })
                    }

                    break

                case Enums.SimaxOperatorSetting.PackageStatusFlow:
                    if (_.isArray(setting)) {
                        setting = setting.map((packageStatusFlowObj: any) => {
                            return new OpPackageStatusFlow(packageStatusFlowObj)
                        })
                    }

                    break

                case Enums.SimaxOperatorSetting.OrderStatusFlow:
                    if (_.isArray(setting)) {
                        setting = setting.map((OrderStatusFlow: any) => {
                            return new OpPackageStatusFlow(OrderStatusFlow)
                        })
                    }

                    break

                default:
                    break
            }
        }

        this.settings.addOrUpdate(settingKey, setting)
    }
    public getSetting(settingKey: Enums.SimaxOperatorSetting): any {
        return this.settings.tryGetValue(settingKey)
    }
    public getSettingJSON(settingKey: Enums.SimaxOperatorSetting): any {
        return OpOperatorSettings.convertSettingToJSON(settingKey, this.getSetting(settingKey))
    }

    public removeSetting(settingKey: Enums.SimaxOperatorSetting): void {
        this.settings.remove(settingKey)
    }
    public removeSettings(): void {
        this.settings = new Dictionary<any>(null)
    }

    public static convertSettingToJSON(settingKey: Enums.SimaxOperatorSetting, value: any) {
        if (settingKey) {
            if (value != null) {
                switch (settingKey) {
                    case Enums.SimaxOperatorSetting.ActiveViews:
                        var activeViews: OpView[] = <OpView[]>value
                        if (activeViews && activeViews.length > 0) {
                            if (!Utils.isJsonSupport(activeViews[0]))
                                activeViews = <any>activeViews.map(v => { return ReferenceTypeComponent.createReferenceObject(Enums.ReferenceType.IdView, v) })
                        }
                        if (activeViews)
                            return activeViews.map(v => { return v.toJSON() })
                        return null

                    case Enums.SimaxOperatorSetting.AllowedDistributors:
                        var allowedDistributors: OpDistributor[] = <OpDistributor[]>value
                        if (allowedDistributors && allowedDistributors.length > 0) {
                            if (!Utils.isJsonSupport(allowedDistributors[0]))
                                allowedDistributors = <any>allowedDistributors.map(v => { return ReferenceTypeComponent.createReferenceObject(Enums.ReferenceType.IdDistributor, v) })
                        }
                        if (allowedDistributors)
                            return allowedDistributors.map(v => { return v.toJSON() })
                        return null

                    case Enums.SimaxOperatorSetting.DataTypeFormatGroup:
                        var dataTypeFormatGroupDetails: OpDataFormatGroupDetails[] = <OpDataFormatGroupDetails[]>value
                        if (dataTypeFormatGroupDetails && dataTypeFormatGroupDetails.length > 0) {
                            if (!Utils.isJsonSupport(dataTypeFormatGroupDetails[0]))
                                dataTypeFormatGroupDetails = <any>dataTypeFormatGroupDetails.map(v => { return ReferenceTypeComponent.createReferenceObject(Enums.ReferenceType.IdDataFormatGroupDetails, v) })
                        }
                        if (dataTypeFormatGroupDetails)
                            return dataTypeFormatGroupDetails.map(v => { return v.toJSON() })
                        return null


                    case Enums.SimaxOperatorSetting.ExportPlugin:
                        let exportPlugins: OpExportPlugin[] = value as OpExportPlugin[]

                        if (exportPlugins && exportPlugins.length > 0) {
                            if (!Utils.isJsonSupport(exportPlugins[0])) {
                                exportPlugins = <any>exportPlugins.map(p => { return new OpExportPlugin(p) })
                            }
                        }

                        if (exportPlugins != null) {
                            return exportPlugins.map(p => { return p.toJSON() })
                        }

                        return null


                    case Enums.SimaxOperatorSetting.LoggedOperator:
                        var operator: OpOperator = new OpOperator(value)

                        if (operator) {
                            if (!Utils.isJsonSupport(operator)) {
                                operator = <any>ReferenceTypeComponent.createReferenceObject(Enums.ReferenceType.IdOperator, operator)
                            }
                        }

                        if (operator) {
                            return operator.toJSON()
                        }

                        return null

                    case Enums.SimaxOperatorSetting.Logo:
                        var logo: OpFile = <OpFile>value
                        if (logo) {
                            if (!Utils.isJsonSupport(logo)) {
                                logo = <any>ReferenceTypeComponent.createReferenceObject(Enums.ReferenceType.IdFile, logo)
                            }
                            if (logo.fileBytes && logo.fileBytes.length > 0 && !Utils.isString(logo.fileBytes)) {
                                logo.fileBytes = CommonHelper.bin2String(<number[]>logo.fileBytes)
                            }
                        }
                        if (logo)
                            return logo.toJSON()
                        return null

                    case Enums.SimaxOperatorSetting.Layout:
                        var files: OpFile[] = <OpFile[]>value
                        if (files && files.length > 0) {
                            if (!Utils.isJsonSupport(files[0]))
                                files = <any>files.map(f => { return ReferenceTypeComponent.createReferenceObject(Enums.ReferenceType.IdFile, f) })
                        }
                        if (files)
                            return files.map(f => { return f.toJSON() })

                    case Enums.SimaxOperatorSetting.ImportPlugin:
                        let plugins: OpImportPlugin[] = <OpImportPlugin[]>value
                        if (plugins && plugins.length > 0) {
                            if (!Utils.isJsonSupport(plugins[0]))
                                plugins = <any>plugins.map(p => { return new OpImportPlugin(p) })
                        }
                        if (plugins)
                            return plugins.map(p => { return p.toJSON() })
                        return null

                    default:
                        return value != null ? typeof value.toJSON === 'function' ? value.toJSON() : value : null
                }
            }
        }
        return null
    }

}